// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mNzFxIsfsEHqTcpQCIP2 {
  cursor: pointer;
}
.mNzFxIsfsEHqTcpQCIP2 span {
  padding-right: 10px;
}`, "",{"version":3,"sources":["webpack://./js/view/page/site-management/component/table/component/action/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,mBAAA;AACJ","sourcesContent":[".show_more {\n  cursor: pointer;\n\n  span {\n    padding-right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"show_more": `mNzFxIsfsEHqTcpQCIP2`
};
export default ___CSS_LOADER_EXPORT___;
